module.exports = __webpack_public_path__ + "img/epk-photo-2.2882781f.jpg";